import { forwardRef } from 'react';
import { statusDefinition } from './statusRegistry';
import type { Tone, WithClassName } from './types';

export type StatusChipProps = WithClassName & (
  | { status: string | null; domain?: string; label?: string; tone?: never }
  | { status?: never; domain?: never; label: string; tone: Tone }
);

export const StatusChip = forwardRef<HTMLSpanElement, StatusChipProps>(function StatusChip(props, ref) {
  const definition = props.tone
    ? { tone: props.tone, label: props.label }
    : statusDefinition(props.status, props.domain);
  return <span ref={ref} className={`ui-status-chip ui-tone-${definition.tone} ${props.className ?? ''}`}>
    {props.label ?? definition.label}
  </span>;
});
